import {
  arimoV26,
  cabinV24,
  interV11,
  latoV23,
  loraV24,
  notoSansV27,
  openSansV29,
  sourceSerifProV15,
  dmSans,
  jetBrainsMonoV18,
  merriweather,
  ptSerif,
  roboto,
  barlowCondensed,
} from './font-faces';
import type { Font } from './types/font';

export const defaultFonts: Font[] = [
  arimoV26,
  cabinV24,
  interV11,
  latoV23,
  loraV24,
  notoSansV27,
  openSansV29,
  sourceSerifProV15,
  dmSans,
  jetBrainsMonoV18,
  merriweather,
  ptSerif,
  roboto,
  barlowCondensed,
];
